import React, { PureComponent } from 'react';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import {
  HOT_LINE,
  registerUrl,
  registerUrlEn,
  supportEmail,
  upgradeUrl,
  upgradeUrlEn,
} from '../../../configs/ContactConfig';
import authProvider from '../../../core/AuthenticationProvider';
import './guest-component.scss';

class GuestComponent extends PureComponent {
  handleSignIn = e => {
    const { locale } = this.props;
    e.preventDefault();
    authProvider.signin({ lang: locale });
  };

  handleSignUp = e => {
    const { locale } = this.props;
    e.preventDefault();
    const mapUrl = {
      en: registerUrlEn,
      vi: registerUrl,
    };

    window.open(mapUrl[locale], '_blank');
  };

  handleUpgrade = e => {
    const { locale } = this.props;
    e.preventDefault();
    const mapUrl = {
      en: upgradeUrlEn,
      vi: upgradeUrl,
    };
    window.open(mapUrl[locale], '_blank');
  };

  isNotLogin = () => {
    const { user } = this.props;
    return !user || !Object.keys(user).length;
  };

  renderFooter = () => {
    if (this.isNotLogin()) {
      return (
        <div className="gp-group-button">
          <div className="has-account">{I18n.t('layout.guest.hasAccount')}</div>

          <button onClick={this.handleSignUp} className="sign-up">
            {I18n.t('layout.guest.signUp')}
          </button>
          <button onClick={this.handleSignIn} className="sign-in">
            {I18n.t('layout.guest.signIn')}
          </button>
        </div>
      );
    }

    return (
      <div className="gp-group-button">
        <button onClick={this.handleUpgrade} className="sign-up">
          {I18n.t('layout.guest.upgrade')}
        </button>
      </div>
    );
  };

  renderLink = () => {
    if (this.isNotLogin()) {
      return (
        <a onClick={this.handleSignIn} href="#">
          {I18n.t('layout.guest.signIn')}
        </a>
      );
    }

    return (
      <a onClick={this.handleUpgrade} href="#">
        {I18n.t('layout.guest.upgrade')}
      </a>
    );
  };

  render() {
    return (
      <div className="guest-component">
        <div className="icon">
          <div className="text">!</div>
          <div className="left-circle" />
          <div className="right-circle" />
        </div>

        <div className="message">
          {I18n.t('layout.guest.please')}
          {this.renderLink()}
          {I18n.t('layout.guest.toAccess')}
        </div>

        <div className="separator" />

        {this.renderFooter()}

        <div className="contact">
          {I18n.t('layout.guest.contact')}
          <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
        </div>

        <div className="hotline">
          {I18n.t('layout.guest.hotline')}{' '}
          <a href={`tel:${HOT_LINE}`}>{HOT_LINE}</a>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.userInfo,
  locale: state.i18n.locale,
});

export default connect(mapStateToProps)(GuestComponent);
